<h1>Data Processing Policy</h1>
<app-card title="Privacy Statements">
  <strong
    >Who is responsible for data processing and whom can data subjects
    contact?</strong
  >
  <p>
    Bern University of Applied Sciences – Department of Business<br />
    Manuel Fischer<br />
    Sustainable Business<br />
    Falkenplatz 16<br />
    3005 Bern, Switzerland<br />
  </p>
  <strong>Which personal data is processed?</strong>
  <p>Personal data is collected through the application. This includes:</p>
  <ul style="margin-top: 0">
    <li>Login data</li>
    <li>
      Behavioral data (according to your voluntary information in the
      questionnaire and the daily entries)
    </li>
  </ul>
  <strong>How long is personal data processed/stored?</strong>
  <p>
    Personal data is stored only for as long as it is necessary to fulfill the
    respective processing purposes. Once the purpose of processing ceases,
    personal data will be deleted or anonymized. If a user remains inactive for
    a period of three years, the data will be deleted or anonymized at the
    latest by that time.
  </p>
  <strong>How is participant anonymity ensured (anonymization)?</strong>
  <p>
    Behavioral data may be used in anonymized form for research purposes.
    Anonymization is considered ensured when the characteristics in the dataset
    apply to at least three individuals.
  </p>
  <strong>Is personal data disclosed to third parties?</strong>
  <p>No personal data is shared with third parties.</p>
  <strong>Right to withdraw consent</strong>
  <p>
    The processing of your personal data is lawful only with your consent. You
    are not required to provide consent; it is given voluntarily. You also have
    the right to withdraw your consent to the processing of personal data at any
    time with effect for the future by contacting the data controller. This
    applies to all your personal data that is not yet anonymized. Refusing or
    withdrawing consent does not result in any legal or other disadvantages.
    Withdrawal of consent means that any future processing of the affected
    personal data becomes inadmissible according to your declaration of
    withdrawal. The legality of processing carried out before the withdrawal
    remains unaffected.
  </p>
  <strong>Right of access</strong>
  <p>
    You have the right to request access to your personal data that has been
    collected and processed by our research group.
  </p>
  <strong>Right to rectification</strong>
  <p>
    You have the right to request the correction of inaccurate personal data
    concerning you.
  </p>
  <strong>Right to erasure</strong>
  <p>
    Under the conditions set out by law, you have the right to request the
    deletion of personal data concerning you, for example, if the data is no
    longer needed for the purpose for which it was collected, if there are no
    legal retention obligations, or if you have withdrawn your consent and there
    is no other legal basis for processing. This right does not apply to
    anonymized data, as these can no longer be linked to a specific individual
    (no identifiability).
  </p>
  <strong>Right to object</strong>
  <p>
    If reasons arise from your particular situation, you have the right to
    object to the processing of your personal data. In such a case, processing
    will generally no longer take place.
  </p>
</app-card>
